import * as OFMSUI from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Field, useFormik, FormikProvider, ErrorMessage } from "formik";
import * as Yup from "yup";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import Swal from "sweetalert2/dist/sweetalert2.js";
import HousingService from "../../../Services/HousingService";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { allowOnlyAlphabetsOnlyy, DashboardServiceReport, FormHeader, LabelHeader, ModuleHeader, NumberValidation, showNotification, SubmitButton } from "../../utils/commonFunctions";
import { store } from "../../../App";
import ShowAlert from "../../alert";

const BankDetails = () => {
    const [bankNamesList, setbankNamesList] = useState();
    const [district, setindistrict] = useState();

    const validationSchema = Yup.object().shape({
        bankname: Yup.string().required("Name is required"),
        branchname: Yup.string().max(60, "Branch name cannot exceed 60 characters").required("Branch name is required"),
        accountno: Yup.string()
            .max(24, "Account number cannot exceed 24 characters")
            .required("Account number is required"),
        ifsc: Yup.string()
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code format")
            .required("IFSC code is required"),
        balance: Yup.string().required("balance is required"),
        operationaccount: Yup.string().required("operationaccount is required"),
        accounttype: Yup.string().required("accounttype is required"),
        accountholder1: Yup.string().max(50, "accountholder 1 name cannot exceed 50 characters").required("accountholder1 is required"),
        accountholder2: Yup.string().when("operationaccount", {
            is: "Joint",
            then: Yup.string().max(50, "accountholder 2 name cannot exceed 50 characters").required("Account holder 2 is required for Joint accounts"),
            otherwise: Yup.string().notRequired(),
        }),
        file: Yup.string().required("file is required"),
    });
    const formik = useFormik({
        initialValues: {
            bankname: "",
            branchname: "",
            ifsc: "",
            accountno: "",
            operationaccount: "Individual",
            accountholder1: "",
            accountholder2: "",
            balance: "",
            remaining_balance: "",
            accounttype: "",
            file: ""
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            console.log(values);
            Swal.fire({
                text: "Are You Sure Want to Submit?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.isConfirmed) {
                    store.dispatch({ type: "SHOW_SPINNER" });
                    let file = document.getElementById("file").files[0];
                    let formData = new FormData();
                    formData.append("file", file);
                    HousingService.fileUploadUrl(formData).then((respose) => {
                        if (respose.data) {
                            let params = {
                                "bankname": values.bankname,
                                "ifsc": values.ifsc,
                                "operationaccount": values.operationaccount,
                                "accountholder1": values.accountholder1,
                                "accountholder2": values.accountholder2,
                                "accountno": values.accountno,
                                "passbookpath": respose.data,
                                "branchname": values.branchname,
                                "balance": values.balance,
                                "remainingbalance": values.balance,
                                "accounttype": values.accounttype,
                            };
                            HousingService.createBankEntryForm(params).then((response) => {
                                if (response?.data?.SCODE === "01") {
                                    showNotification("success", "Submitted successfully");
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 1000);
                                }
                            })
                        }
                    }).catch((error) => {
                        ShowAlert("File name should not contain symbols or special characters.", "error");
                        console.log(error);
                    }).finally(() => {
                            store.dispatch({ type: "HIDE_SPINNER" });
                    });;
                }
            });
        }
    })
    React.useEffect(() => {
        HousingService.fetchBankName().then((res) => {
            if (res.data) {
                let options = res.data.map((item, i) => {
                    if (item !== null) {
                        return (
                            <option key={i} value={item.bankshortname}> {item.bankid} {"-"} {item.bankfullname} </option>
                        );
                    }
                });
                setbankNamesList(options);
            }
        });

        HousingService.fetchDistrictNames().then((res) => {
            const response = res.data[0].display_name;
            const username = localStorage.getItem("username");
            if (res.data) {
                if (username && username.includes("DH")) { const district = response; setindistrict(district); }
                else { setindistrict(response); }
            }
        });
    }, []);
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const maxSize = 2 * 1024 * 1024;
            const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
            if (!allowedTypes.includes(file.type)) {
                ShowAlert("Upload JPG, JPEG, PNG and Pdf files Only", "error");
                e.target.value = "";
                return false;
            }
            if (file.size > maxSize) {
                ShowAlert("File size exceeds the limit of 2 MB Only", "error");
                e.target.value = "";
                return false;
            }
        }
    };
    return (
        <>
            <NavigationServicesHeader />
            <ModuleHeader title="Bank Details Entry" />
            <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
                <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                        <DashboardServiceReport title="Service" />
                        <OFMSUI.Row className="mb-3">
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                <OFMSUI.InputGroup className=" mt-4">
                                    <span className="label-text-style"> <b>District Name</b> </span>
                                    <div className="emptyspace3">{district}</div>
                                </OFMSUI.InputGroup>
                            </OFMSUI.Col>

                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                                <LabelHeader title="Name of the Bank" />
                                <Field component="select" name="bankname" className={formik.touched.bankname && formik.errors.bankname ? "form-control is-invalid" : "form-control"} >
                                    <option value="">Select</option>
                                    {bankNamesList}
                                </Field>
                                <ErrorMessage name="bankname" component={"div"} className="text-error" />
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                                <LabelHeader title="Name of the Branch" />
                                <Field name="branchname" placeholder="Enter Branch name" className={formik.touched.branchname && formik.errors.branchname ? "form-control is-invalid" : "form-control"} type="text" onKeyPress={(e) => allowOnlyAlphabetsOnlyy(e)}/>
                                <ErrorMessage name="branchname" component={"div"} className="text-error" />
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                                <LabelHeader title="Account Number" />
                                <Field name="accountno" placeholder="Enter Account No." className={formik.touched.accountno && formik.errors.accountno ? "form-control is-invalid" : "form-control"} onKeyPress={(e) => NumberValidation(e)} type="text" minLength={12} />
                                <ErrorMessage name="accountno" component={"div"} className="text-error" />
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                                <LabelHeader title="IFSC Code" />
                                <Field name="ifsc" placeholder="Enter IFSC Code" className={formik.touched.ifsc && formik.errors.ifsc ? "form-control is-invalid" : "form-control"} type="text" />
                                <ErrorMessage name="ifsc" component={"div"} className="text-error" />

                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                                <LabelHeader title="Opening Balance" />
                                <Field name="balance" placeholder="Enter Balance" className={formik.touched.balance && formik.errors.balance ? "form-control is-invalid" : "form-control"} type="number" onKeyPress={(e) => NumberValidation(e)} />
                                <ErrorMessage name="balance" component={"div"} className="text-error" />

                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                                <LabelHeader title="Operation of Account" />
                                <Field component="select" name="operationaccount" className={formik.touched.operationaccount && formik.errors.operationaccount ? "form-control is-invalid" : "form-control"} >
                                    <option value="">Select</option>
                                    <option value="Individual">Individual</option>
                                    <option value="Joint">Joint</option>
                                </Field>
                                <ErrorMessage name="operationaccount" component={"div"} className="text-error" />

                            </OFMSUI.Col>

                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                                <LabelHeader title="Type of Account:" />
                                <Field component="select" name="accounttype" className={formik.touched.accounttype && formik.errors.accounttype ? "form-control is-invalid" : "form-control"} >
                                    <option value="">Select</option>
                                    <option value="SB">SB</option>
                                    <option value="Current">Current</option>
                                </Field>
                                <ErrorMessage name="accounttype" component={"div"} className="text-error" />

                            </OFMSUI.Col>
                        </OFMSUI.Row>
                        <FormHeader title="Account Holder Details" />
                        <OFMSUI.Row>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                                <LabelHeader title="Name of Account Holder(1)" />
                                <Field name="accountholder1" placeholder="Enter Name" className={formik.touched.accountholder1 && formik.errors.accountholder1 ? "form-control is-invalid" : "form-control"} type="text" onKeyPress={(e) => allowOnlyAlphabetsOnlyy(e)} />
                                <ErrorMessage name="accountholder1" component={"div"} className="text-error" />

                            </OFMSUI.Col>
                            {formik.values.operationaccount == "Joint" && (<>
                                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                                    <LabelHeader title="Name of Account Holder(2)" />
                                    <Field name="accountholder2" placeholder="Enter Name" className={formik.touched.accountholder2 && formik.errors.accountholder2 ? "form-control is-invalid" : "form-control"} type="text" onKeyPress={(e) => allowOnlyAlphabetsOnlyy(e)} />
                                    <ErrorMessage name="accountholder2" component={"div"} className="text-error" />

                                </OFMSUI.Col>
                            </>)}
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3">
                                <LabelHeader title="File Upload (File name should not contain symbols or special characters.)" />
                                <div className="input-group">
                                    <Field type="file" name="file" id="file" className={formik.touched.file && formik.errors.file ? "form-control is-invalid" : "form-control"} accept="application/pdf" onChange={(e) => { handleFileChange(e); formik.handleChange(e) }} />
                                    <ErrorMessage name="file" component={"div"} className="text-error" />
                                </div>
                            </OFMSUI.Col>

                        </OFMSUI.Row>
                        <SubmitButton title="Submit" />



                    </Form>
                </FormikProvider>
            </OFMSUI.Container>
        </>
    )
}

export default BankDetails
